export default {
  add: {
    method: 'POST',
    url: '/client/order/ID/document'
  },
  archive: {
    method: 'DELETE',
    url: '/client/order/ID/document/archive'
  },
  delete: {
    method: 'DELETE',
    url: '/client/order/ID/document'
  }
}
